import { Controller } from "@hotwired/stimulus";

// Selezione a gruppi (lavorazioni esterne): checkbox "tutto il gruppo", conteggio e abilitazione dell'azione.
export default class extends Controller {
  static targets = ["check", "group", "count", "submit"];

  connect() {
    this.update();
  }

  toggleGroup(event) {
    this.checksOf(event.target.dataset.group).forEach((c) => { c.checked = event.target.checked; });
    this.update();
  }

  update() {
    this.groupTargets.forEach((g) => {
      const checks = this.checksOf(g.dataset.group);
      const n = checks.filter((c) => c.checked).length;
      g.checked = n > 0 && n === checks.length;
      g.indeterminate = n > 0 && n < checks.length;
    });
    const n = this.checkTargets.filter((c) => c.checked).length;
    this.countTargets.forEach((el) => { el.textContent = n; });
    this.submitTargets.forEach((b) => { b.disabled = n === 0; });
  }

  checksOf(gruppo) {
    return this.checkTargets.filter((c) => c.dataset.group === gruppo);
  }
}
